var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 4.66667H11.3337V6H12.667V4.66667Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 7.33333H11.3337V8.66667H12.667V7.33333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 10H11.3337V11.3333H12.667V10Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 7.33333V14H4.66699V10.6667H6.00033V14H10.0003V7.33333L5.33366 4L0.666992 7.33333ZM8.66699 12.6667H7.33366V9.33333H3.33366V12.6667H2.00033V8L5.33366 5.66667L8.66699 8V12.6667Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 2V3.31333L8.00033 4.26667V3.33333H14.0003V12.6667H11.3337V14H15.3337V2H6.66699Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOffice);
export default __webpack_public_path__ + "static/media/home_office.ea3125e4caf53f9e52744f67c4f2c6db.svg";
export { ForwardRef as ReactComponent };